export function AuthStepProgress({
  currentStep,
  totalSteps = 2,
  stepTitle,
  className = '',
}) {
  const stepPadded = String(currentStep).padStart(2, '0');
  const totalPadded = String(totalSteps).padStart(2, '0');
  const progressPercent = Math.min(
    100,
    Math.max(0, (currentStep / totalSteps) * 100),
  );

  return (
    <div className={`flex flex-col gap-2.5 mb-6 ${className}`}>
      <div className="flex justify-between items-center text-body sm:text-h6 font-sf-pro-display">
        <div className="uppercase tracking-wider">
          <span className="text-primary">STEP {stepPadded}</span>
          <span className="text-text-muted"> / {totalPadded}</span>
        </div>
        <span className="text-h5-normal text-text-primary normal-case tracking-normal">
          {stepTitle}
        </span>
      </div>
      <div
        className="h-2 w-full overflow-hidden rounded-full bg-border-default"
        role="progressbar"
        aria-valuenow={currentStep}
        aria-valuemin={1}
        aria-valuemax={totalSteps}
        aria-label={`Step ${currentStep} of ${totalSteps}`}
      >
        <div
          className="h-full bg-primary transition-[width] duration-500 ease-out"
          style={{ width: `${progressPercent}%` }}
        />
      </div>
    </div>
  );
}
